import {getLocalStorage} from '../../util/LocalStorage'

const DAR_SETTINGS_COLLAPSED_STATE_LS_KEY = 'darSettingsCollapsedState'

export function storeDARSettingsCollapsedState(collapsedState) {
    getLocalStorage().setItem(DAR_SETTINGS_COLLAPSED_STATE_LS_KEY, collapsedState)
}

export function getStoredDARSettingsCollapsedState() {
    return getLocalStorage().getItem(DAR_SETTINGS_COLLAPSED_STATE_LS_KEY)
}


// WEBPACK FOOTER //
// ./web/js/administration/darSettings/utils.js